import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`This document describes the steps that you should take to resolve
naming disputes with other npm publishers.  It also describes the steps
you should take if you think a name `}<a parentName="p" {...{
        "href": "#trademarks"
      }}>{`infringes your trademark`}</a>{`.`}</p>
    <p>{`This document is additive to the guidelines in the
`}<a parentName="p" {...{
        "href": "/policies/conduct"
      }}>{`npm Code of Conduct`}</a>{` and
`}<a parentName="p" {...{
        "href": "/policies/open-source-terms"
      }}>{`npm Open-Source terms`}</a>{`.
Nothing in this document should be interpreted to contradict any aspect
of the npm Code of Conduct or Open-Source Terms.`}</p>
    <h2>{`tl;dr`}</h2>
    <ol>
      <li parentName="ol">{`Open a support ticket at `}<a parentName="li" {...{
          "href": "https://support.github.com/contact/npm-name-disputes"
        }}>{`https://support.github.com/contact/npm-name-disputes`}</a>{`.`}</li>
      <li parentName="ol">{`Fill out the form with as much detail as possible.`}</li>
      <li parentName="ol">{`Support will address your request. Please note submitting a report does not
guarantee the transfer of a package, org, or username.`}</li>
    </ol>
    <h2>{`When to use this process`}</h2>
    <p>{`This process is an excellent way to:`}</p>
    <ul>
      <li parentName="ul">{`Request a name that you believe is currently misleading or could be confused with a name used by your company or open source project`}</li>
      <li parentName="ul">{`Request a name related to your company or open source project that cannot be claimed via account recovery`}</li>
    </ul>
    <p>{`This process does not apply if the package violates our
`}<a parentName="p" {...{
        "href": "/policies/open-source-terms"
      }}>{`Terms of Use`}</a>{`,
in particular our
`}<a parentName="p" {...{
        "href": "/policies/open-source-terms#acceptable-use"
      }}>{`Acceptable Use`}</a>{`
and `}<a parentName="p" {...{
        "href": "/policies/open-source-terms#acceptable-content"
      }}>{`Acceptable Content`}</a>{`
rules, or our `}<a parentName="p" {...{
        "href": "/policies/conduct"
      }}>{`Code of Conduct`}</a>{`.
Those documents refer to this one to resolve cases of "squatting"; see
below.`}</p>
    <p>{`If you see bad behavior or content you believe is unacceptable, refer to
the Code of Conduct for guidelines on
`}<a parentName="p" {...{
        "href": "/policies/conduct#reporting-violations-of-this-code-of-conduct"
      }}>{`reporting violations`}</a>{`.
`}<strong parentName="p">{`You are never expected to resolve abusive behavior on your own.`}</strong>{`
`}<strong parentName="p">{`We are here to help.`}</strong></p>
    <h2>{`When not to use this process`}</h2>
    <p>{`This process is not available for dispute requests due to lack of activity
related to a specific name.`}</p>
    <p>{`Please also note there are cases where a party may have claim to a specific name,
but giving that name to the requesting party would pose a supply-chain risk
to the npm ecosystem. In such cases, requests may be denied independent of
the validity of the claim.`}</p>
    <h2>{`Trademarks`}</h2>
    <p>{`npm processes Trademark claims under GitHub's `}<a parentName="p" {...{
        "href": "https://docs.github.com/site-policy/content-removal-policies/github-trademark-policy"
      }}>{`Trademark Policy`}</a>{`.`}</p>
    <p>{`If you think another npm publisher is infringing your trademark, such
as by using a confusingly similar package, org, or user account name, please submit a Trademark Policy Violation Report via our `}<a parentName="p" {...{
        "href": "https://support.github.com/contact/trademark-policy"
      }}>{`form`}</a>{`.`}</p>
    <p>{`Use of npm's own trademarks is covered by our `}<a parentName="p" {...{
        "href": "/policies/logos-and-usage"
      }}>{`Logo and Usage Policy`}</a>{`.`}</p>
    <h2>{`Changes`}</h2>
    <p>{`This is a living document and may be updated from time to time.
Please refer to the `}<a parentName="p" {...{
        "href": "https://github.com/npm/documentation/blob/main/content/policies/disputes.mdx"
      }}>{`git history for this
document`}</a>{`
to view the changes.`}</p>
    <h2>{`Definitions`}</h2>
    <h3>{`Squatting`}</h3>
    <p>{`It is against npm's
`}<a parentName="p" {...{
        "href": "/policies/open-source-terms#acceptable-content"
      }}>{`Terms of Use`}</a>{`
to publish a package, register a user name or an organization name
simply for the purposes of reserving it for future use.`}</p>
    <p>{`We do not pro-actively scan the registry for squatted packages, so
the fact that a name is in use does not mean we consider it valid.
The standards for what we consider squatting depend on what is being
squatted:`}</p>
    <h4>{`Packages`}</h4>
    <p>{`Package names are considered squatted if the package has no genuine
function.`}</p>
    <h4>{`Organizations`}</h4>
    <p>{`Organization names are considered squatted if there are no packages
published within a reasonable time. If an organization is a paid
organization, it may have private packages that are invisible to
third parties. For privacy reasons, we cannot reveal whether or not
an organization has private packages, so a paid organization will
never be considered squatted.`}</p>
    <h4>{`User names`}</h4>
    <p>{`We are extremely unlikely to transfer control of a user name, as it
is totally valid to be an npm user and never publish any packages:
for instance, you might be part of an organization or need read-only
access to private packages.`}</p>
    <h2>{`License`}</h2>
    <p>{`Copyright (C) npm, Inc., All rights reserved`}</p>
    <p>{`This document may be reused under a `}<a parentName="p" {...{
        "href": "https://creativecommons.org/licenses/by-sa/4.0/"
      }}>{`Creative Commons
Attribution-ShareAlike
License`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      